import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { ExternalLink, ChevronLeft, ChevronRight } from 'lucide-react';

const Press = () => {
  const { t } = useLanguage();
  const [currentImageIndices, setCurrentImageIndices] = useState({});

  const navigateImage = (itemId, direction, totalImages) => {
    setCurrentImageIndices((prev) => {
      const currentIndex = prev[itemId] || 0;
      const newIndex = direction === 'next' ?
      (currentIndex + 1) % totalImages :
      (currentIndex - 1 + totalImages) % totalImages;
      return { ...prev, [itemId]: newIndex };
    });
  };

  const pressItems = [
    {
      id: 0,
      type: 'Media',
      title: 'Contour Podcast 2026',
      publication: '2026, Sofia',
      description: 'The process, presence and soul behind a space with character.',
      images: [
        'https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/ad17lam5_Screenshot_2026-07-09_at_0.01.25.png'
      ],
      link: 'https://www.youtube.com/watch?v=5XTHpyfTjpc&t=847s',
      imagePosition: 'center 40%'
    },
    {
      id: 1,
      type: 'Press',
      title: "Непреходна елегантност в съвременни детайли",
      publication: 'February 2026, Градът Magazine',
      description: 'Grand Hotel Varna - новият модел на брандираните жилища',
      images: [
        'https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/y7mhesv2_Screenshot_2026-04-13_at_21.40.00_copy.jpg'
      ],
      link: 'https://gradat.bg/content/grand-hotel-varna-noviyat-model-na-brandiranite-zhilishcha',
      imagePosition: 'center 30%'
    },
    {
      id: 2,
      type: 'Speaking',
      title: 'New Norm Hospitality: Branded Residences',
      publication: 'October 2025, Sofia Hotel Balkan',
      description: 'A Blueprint for Capital and Design',
      images: [
        'https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/6cpf7dre_Screenshot_2026-03-02_at_23.36.39.png',
        'https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/pu7bi1f5_1760337235923.jpeg',
        'https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/xsibo018_1760337235963.jpeg',
        'https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/15mk0wu5_1760337236150.jpeg',
        'https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/6hie5wqp_1760337236307.jpeg'
      ],
      link: 'https://www.newnormhospitality.com/branded-residences-forum-sofia-2025-bg',
      imagePosition: 'center 20%'
    },
    {
      id: 3,
      type: 'Speaking',
      title: '196+ Forum Milano',
      publication: 'April 2025, Milano, Italy',
      description: 'Holistic thinking - balancing People, Purpose and Planet',
      images: [
        'https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/fz2kbtyu_1741100913616.jpeg',
        'https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/zvkkb883_01.jpg',
        'https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/re17zped_Screenshot_2026-04-13_at_21.45.13.jpg',
        'https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/ibxu7yud_Screenshot_2026-04-13_at_21.45.32.jpg',
        'https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/8bjwvx96_Screenshot_2026-04-13_at_21.46.01.jpg'
      ],
      link: 'https://www.196plus.com/196plus-forum/196plus-forum-milan/',
      imagePosition: 'center 30%'
    },
    {
      id: 4,
      type: 'Media',
      title: 'Contour Podcast',
      publication: '2025, Sofia',
      description: 'In-depth conversation on design, hospitality and creative process',
      images: [
        'https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/k5yr90pe_Screenshot_2026-04-13_at_22.29.12.png'
      ],
      link: 'https://www.youtube.com/watch?v=yjlHqyAY3Ho&t=5335s',
      imagePosition: 'center 35%'
    },
    {
      id: 5,
      type: 'Speaking',
      title: 'Createch Summit',
      publication: 'March 2025, South East Europe',
      description: 'Designing tomorrow: Sustainability in focus',
      images: [
        'https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/ev0od7qt_IMG_1875.jpg'
      ],
      link: 'https://createchsummit.eu',
      imagePosition: 'center 40%'
    },
    {
      id: 6,
      type: 'Speaking',
      title: 'Italian Design Day Sofia',
      publication: '2022, Confindustria Italia - Bulgaria',
      description: 'Re-Generation, Design and new technologies for a sustainable future',
      images: [
        'https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/c155iv4r_IVOO1252.jpg',
        'https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/oabz56sf_7.jpg',
        'https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/7q9pdeeb_Confindustria-312.jpg',
        'https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/9czmsvn3_Confindustria-317.jpg',
        'https://customer-assets.emergentagent.com/job_sophisticated-spaces-1/artifacts/z58v0km7_post_Mustakova_final_BG.png'
      ],
      link: 'https://confindustriabulgaria.bg/bg/italian-design-day-sofia-2022/',
      imagePosition: 'center 35%'
    }
  ];

  return (
    <section className="min-h-screen py-24 md:py-32 px-6 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Heading - Larger */}
        <h1 className="text-6xl md:text-7xl lg:text-8xl font-light text-[#2C2C2C] lowercase mb-20">
          {t('press.heading')}
        </h1>

        {/* Featured Press Items with Images */}
        <div className="mb-24">
          <h2 className="text-3xl font-light text-[#2C2C2C] lowercase mb-12">
            featured
          </h2>
          
          <div className="grid md:grid-cols-2 gap-8">
            {pressItems.map((item) => {
              const currentImageIndex = currentImageIndices[item.id] || 0;
              const currentImage = item.images[currentImageIndex];
              const hasMultipleImages = item.images.length > 1;

              return (
                <a
                  key={item.id}
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group block"
                >
                  {/* Image with Carousel */}
                  <div className="relative overflow-hidden bg-[#F6F4F1] mb-4 aspect-[4/3]">
                    <img
                      src={currentImage}
                      alt={item.title}
                      className="w-full h-full object-cover transition-all duration-700 grayscale group-hover:grayscale-0 group-hover:scale-105"
                      style={{ objectPosition: item.imagePosition }}
                    />

                    <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors duration-300" />
                    
                    {/* Type Badge */}
                    <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1">
                      <span className="text-xs tracking-widest uppercase text-[#2C2C2C] font-light">
                        {item.type}
                      </span>
                    </div>
                    
                    {/* External Link Icon */}
                    <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <div className="bg-white/90 backdrop-blur-sm rounded-full p-2">
                        <ExternalLink className="w-4 h-4 text-[#2C2C2C]" />
                      </div>
                    </div>

                    {/* Carousel Navigation Arrows */}
                    {hasMultipleImages && (
                      <>
                        {/* Previous Arrow */}
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            navigateImage(item.id, 'prev', item.images.length);
                          }}
                          className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-2 opacity-0 group-hover:opacity-100 transition-all duration-300 z-10"
                          aria-label="Previous image"
                        >
                          <ChevronLeft className="w-5 h-5 text-[#2C2C2C]" />
                        </button>

                        {/* Next Arrow */}
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            navigateImage(item.id, 'next', item.images.length);
                          }}
                          className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white rounded-full p-2 opacity-0 group-hover:opacity-100 transition-all duration-300 z-10"
                          aria-label="Next image"
                        >
                          <ChevronRight className="w-5 h-5 text-[#2C2C2C]" />
                        </button>

                        {/* Image Counter */}
                        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-white/90 backdrop-blur-sm px-3 py-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                          <span className="text-xs text-[#2C2C2C] font-light">
                            {currentImageIndex + 1} / {item.images.length}
                          </span>
                        </div>
                      </>
                    )}
                  </div>

                  {/* Content */}
                  <div>
                    <p className="text-sm tracking-widest uppercase text-[#6B6B6B] mb-2 font-light">
                      {item.publication}
                    </p>
                    <h4 className="text-xl font-light text-[#2C2C2C] mb-2 group-hover:text-[#2C1810] transition-colors duration-300">
                      {item.title}
                    </h4>
                    <p className="text-[#5A5A5A] font-light">
                      {item.description}
                    </p>
                  </div>
                </a>
              );
            })}
          </div>
        </div>

        {/* Awards */}
        <div className="mb-24">
          <h2 className="text-3xl font-light text-[#2C2C2C] lowercase mb-8">
            {t('press.awards.heading')}
          </h2>
          
          <div className="space-y-4 mb-8">
            {t('press.awards.list').map((award) => (
              <div 
                key={`${award.year}-${award.award}`}
                className="grid grid-cols-12 gap-4 py-4 border-b border-[#E5E5E5] text-[#2C2C2C]"
              >
                <div className="col-span-2 text-lg font-light">
                  {award.year}
                </div>
                <div className="col-span-4 text-lg font-light">
                  {award.award}
                </div>
                <div className="col-span-4 text-lg font-light text-[#5A5A5A]">
                  {award.project}
                </div>
                <div className="col-span-2 text-lg font-light text-[#5A5A5A]">
                  {award.status}
                </div>
              </div>
            ))}
          </div>

          <p className="text-sm font-light text-[#5A5A5A] italic">
            {t('press.awards.attribution')}
          </p>
        </div>

        {/* Speaking */}
        <div className="mb-24">
          <h2 className="text-3xl font-light text-[#2C2C2C] lowercase mb-8">
            {t('press.speaking.heading')}
          </h2>
          
          <div className="space-y-4">
            {t('press.speaking.list').map((item) => (
              <div 
                key={`${item.year}-${item.event}`}
                className="flex gap-8 py-4 border-b border-[#E5E5E5]"
              >
                <div className="text-lg font-light text-[#2C2C2C] w-24">
                  {item.year}
                </div>
                <div className="flex-1">
                  <p className="text-lg font-light text-[#2C2C2C]">
                    <strong>{item.event}</strong> — {item.location}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Jury */}
        <div className="mb-24">
          <h2 className="text-3xl font-light text-[#2C2C2C] lowercase mb-8">
            {t('press.jury.heading')}
          </h2>
          
          <div className="space-y-4">
            {t('press.jury.list').map((item) => (
              <div 
                key={`${item.year}-${item.event}`}
                className="py-4 border-b border-[#E5E5E5]"
              >
                <div className="flex gap-8 mb-2">
                  <div className="text-lg font-light text-[#2C2C2C] w-24">
                    {item.year}
                  </div>
                  <div className="flex-1">
                    <p className="text-lg font-light text-[#2C2C2C]">
                      <strong>{item.event}</strong>
                    </p>
                  </div>
                </div>
                <p className="text-sm font-light text-[#5A5A5A] ml-32">
                  {item.note}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Closing */}
        <p className="text-lg font-light text-[#5A5A5A] italic">
          {t('press.closing')}
        </p>
      </div>
    </section>
  );
};

export default Press;
